// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import A3MailController from "./a3_mail_controller"
application.register("a3-mail", A3MailController)

import AiPromptBuilderController from "./ai_prompt_builder_controller"
application.register("ai-prompt-builder", AiPromptBuilderController)

import AiInsightsStreamController from "./ai_insights_stream_controller"
application.register("ai-insights-stream", AiInsightsStreamController)

import AiInsightsPresetsController from "./ai_insights_presets_controller"
application.register("ai-insights-presets", AiInsightsPresetsController)

import AutoSubmitController from "./auto_submit_controller"
application.register("auto-submit", AutoSubmitController)

import BatchUploadController from "./batch_upload_controller"
application.register("batch-upload", BatchUploadController)

import CheckboxController from "./checkbox_controller"
application.register("checkbox", CheckboxController)

import ChatWaitController from "./chat_wait_controller"
application.register("chat-wait", ChatWaitController)

import CommandController from "./command_controller"
application.register("command", CommandController)

import ConstructionDrawingIngestStatusController from "./construction_drawing_ingest_status_controller"
application.register("construction-drawing-ingest-status", ConstructionDrawingIngestStatusController)

import ConstructionDrawingTakeoffController from "./construction_drawing_takeoff_controller"
application.register("construction-drawing-takeoff", ConstructionDrawingTakeoffController)

import ConstructionDrawingWorkspaceController from "./construction_drawing_workspace_controller"
application.register("construction-drawing-workspace", ConstructionDrawingWorkspaceController)

import CdCollapseController from "./cd_collapse_controller"
application.register("cd-collapse", CdCollapseController)

import CdSymbolsTableController from "./cd_symbols_table_controller"
application.register("cd-symbols-table", CdSymbolsTableController)

import CdIngestSelectController from "./cd_ingest_select_controller"
application.register("cd-ingest-select", CdIngestSelectController)

import CdSheetPreviewController from "./cd_sheet_preview_controller"
application.register("cd-sheet-preview", CdSheetPreviewController)

import CdLegendCropController from "./cd_legend_crop_controller"
application.register("cd-legend-crop", CdLegendCropController)

import CdShellController from "./cd_shell_controller"
application.register("cd-shell", CdShellController)

import CdPhaseCockpitController from "./cd_phase_cockpit_controller"
application.register("cd-phase-cockpit", CdPhaseCockpitController)

import CustomerContactsController from "./customer_contacts_controller"
application.register("customer-contacts", CustomerContactsController)

import EstimateItemsController from "./estimate_items_controller"
application.register("estimate-items", EstimateItemsController)

import EstimatePanelController from "./estimate_panel_controller"
application.register("estimate-panel", EstimatePanelController)

import EstimatesController from "./estimates_controller"
application.register("estimates", EstimatesController)

import EstimatesTableController from "./estimates_table_controller"
application.register("estimates-table", EstimatesTableController)

import EstimatesPricingStreamController from "./estimates_pricing_stream_controller"
application.register("estimates-pricing-stream", EstimatesPricingStreamController)

import GenericSortableController from "./generic_sortable_controller"
application.register("generic-sortable", GenericSortableController)

import HelloController from "./hello_controller"
application.register("hello", HelloController)

import ListFilterController from "./list_filter_controller"
application.register("list-filter", ListFilterController)

import MoveItemsController from "./move_items_controller"
application.register("move-items", MoveItemsController)

import LlmEndpointController from "./llm_endpoint_controller"
application.register("llm-endpoint", LlmEndpointController)

import PanelsSortableController from "./panels_sortable_controller"
application.register("panels-sortable", PanelsSortableController)

import SidebarCollapseController from "./sidebar_collapse_controller"
application.register("sidebar-collapse", SidebarCollapseController)

import ProgressController from "./progress_controller"
application.register("progress", ProgressController)

import ProjectFilterController from "./project_filter_controller"
application.register("project-filter", ProjectFilterController)

import ResetFormController from "./reset_form_controller"
application.register("reset-form", ResetFormController)

import ScrollController from "./scroll_controller"
application.register("scroll", ScrollController)

import Select22Controller from "./select22_controller"
application.register("select22", Select22Controller)

import SimpleSelect2Controller from "./simple_select2_controller"
application.register("simple-select2", SimpleSelect2Controller)

import ShiftCheckboxController from "./shift_checkbox_controller"
application.register("shift-checkbox", ShiftCheckboxController)

import SortableController from "./sortable_controller"
application.register("sortable", SortableController)

import SovFormController from "./sov_form_controller"
application.register("sov-form", SovFormController)

import SubmitFormController from "./submit_form_controller"
application.register("submit-form", SubmitFormController)

import TodoController from "./todo_controller"
application.register("todo", TodoController)

import TrackChangesController from "./track_changes_controller"
application.register("track-changes", TrackChangesController)

import VisibilityController from "./visibility_controller"
application.register("visibility", VisibilityController)
